import DetailService from "../../API/orders/cutting/detail/DetailService";
import {normalizeModelDetail} from "../cutting/normalizeModelDetail";

const modelDetailCache = new Map();
const modelDetailPending = new Map();

const cacheKey = (id) => String(id);

export const getModelDetailCached = (id) => {
    const key = cacheKey(id);

    if (modelDetailCache.has(key)) {
        return Promise.resolve(modelDetailCache.get(key));
    }

    if (modelDetailPending.has(key)) {
        return modelDetailPending.get(key);
    }

    const promise = DetailService.getModelDetailById(id)
        .then((response) => {
            const normalized = normalizeModelDetail(response.data);
            modelDetailCache.set(key, normalized);
            return normalized;
        })
        .finally(() => {
            modelDetailPending.delete(key);
        });

    modelDetailPending.set(key, promise);
    return promise;
};

export const clearModelDetailCache = (id) => {
    if (id == null) {
        modelDetailCache.clear();
        modelDetailPending.clear();
        return;
    }
    const key = cacheKey(id);
    modelDetailCache.delete(key);
    modelDetailPending.delete(key);
};

/** Сброс кэша и повторный GET — для экрана обработки после изменений контура. */
export const refetchModelDetailCached = (id) => {
    clearModelDetailCache(id);
    return getModelDetailCached(id);
};
